import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {AsyncStatusesEnum} from '../../../../../../../shared/helpers/src/types/asyncStatuses';
import {Button} from '../../../../../../../shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroup} from '../../../../../../../shared/ui/src/components/buttons/buttonGroup/buttonGroup';
import {ButtonGroupSpacer} from '../../../../../../../shared/ui/src/components/buttons/buttonGroup/buttonGroupSpacer';

/*
 * Props.
 */

interface MergeContactsSidePanelFooterProps {
  status?: AsyncStatusesEnum;
  isMerging: boolean;
  onCloseSidePanel: Handler;
  onMergeClick: Handler;
}

/*
 * Style.
 */

interface StyledButtonGroupProps {
  $status?: AsyncStatusesEnum;
}

const StyledButtonGroup = styled(ButtonGroup)<StyledButtonGroupProps>`
  padding: 20px;

  ${(p) => maybeAddBorderStyles(p.$status)};
`;

function maybeAddBorderStyles(status?: AsyncStatusesEnum) {
  if (status === AsyncStatusesEnum.LOADED) {
    return css`
      border-top: 1px solid ${(p) => p.theme.greys.shade30};
    `;
  }
  return '';
}

/*
 * Component.
 */

export const MergeContactsSidePanelFooter: FC<MergeContactsSidePanelFooterProps> = (props) => {
  const {status, isMerging, onCloseSidePanel, onMergeClick} = props;
  const isDisabled = status !== AsyncStatusesEnum.LOADED;

  return (
    <StyledButtonGroup $status={status}>
      <ButtonGroupSpacer />
      <Button onClick={onCloseSidePanel} isDisabled={isMerging}>
        <Trans id="contacts-manager-merge-sidepanel-cancel">Cancel</Trans>
      </Button>
      <Button
        variant={ButtonVariantsEnum.PRIMARY}
        isDisabled={isDisabled || isMerging}
        onClick={onMergeClick}
      >
        <Trans id="contacts-manager-merge-sidepanel-merge">Merge</Trans>
      </Button>
    </StyledButtonGroup>
  );
};
